import React from "react";
import { useTranslation } from "react-i18next";
import { role } from "../../Constants/role";

const AdminListTable = ({ adminList,isSuperAdmin }) => {
    const { t } = useTranslation();
      
        const getRoleLabel = (roleId) => {
  const roleKey = Object.keys(role).find(
    (key) => role[key] === roleId
  );

  if (!roleKey) return "N/A";

  const ROLE_LABELS = {
    TerminalAdmin: t("city_admin", "City Admin"),
    superCityAdmin: t("super_city_admins", "Super City Admin"),
    contentCreator: t("citizen", "Citizen"),
  };

  return ROLE_LABELS[roleKey] || roleKey;
};


    return (
        <div className="overflow-x-auto rounded-xl shadow">
            <table className="min-w-full bg-white">
                <thead className="bg-gray-100 text-left">
                    <tr>
                        <th className="py-3 px-4">Email</th>
                        <th className="py-3 px-4">{t("role")}</th>
                        <th className="py-3 px-4">{t("createdAt")}</th>
                        <th className="py-3 px-4">{t("onboarded")}</th>
                    </tr>
                </thead>
                <tbody>
                    {adminList?.length === 0 && (
                        <tr className="border-t hover:bg-gray-50 text-center">
                            <td colSpan={4} className="py-4 px-6 text-gray-500">
                                {t("no_admin_created")}
                            </td>
                        </tr>
                    )}
                    {adminList?.map((admin) => (
                        <tr key={admin.id} className="border-t hover:bg-gray-50">
                            <td className="py-3 px-4">{admin.email}</td>
                            <td className="py-3 px-4">
                                {getRoleLabel(admin.roleId)}
                            </td>
                            <td className="py-3 px-4 capitalize">
                                {new Intl.DateTimeFormat("de-DE", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric"
                                }).format(Date.parse(admin.createdAt))}
                            </td>
                            <td className="py-3 px-4">
                                <label className="inline-flex items-center cursor-not-allowed opacity-60">
                                    <input
                                        type="checkbox"
                                        checked={admin.onBoarded}
                                        className="sr-only peer"
                                        readOnly
                                        disabled
                                    />
                                    <div className="w-11 h-6 bg-gray-300 rounded-full peer peer-checked:bg-green-400 transition duration-300 relative pointer-events-none">
                                        <div className="absolute left-1 top-1 w-4 h-4 bg-white rounded-full shadow-sm transition-transform duration-300 transform peer-checked:translate-x-5" />
                                    </div>
                                </label>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default AdminListTable;
